import { render, staticRenderFns } from "./SwiperBox.vue?vue&type=template&id=4f3aaf54"
import script from "./SwiperBox.vue?vue&type=script&lang=js"
export * from "./SwiperBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports